import { errorContentCache, systemErrorCache } from '../context/appCache'
import { PageviewTealiumEvent } from './tealiumwrapper'
import { PAGE_NAMES } from '../constants/tealiumData'
import { getErrorData, isGenericError } from './errorMapping'

const getReplaceContent = (msg, content, pattern) =>
  msg.replace(pattern, content)
const handleVerifyBillError = (
  error,
  setSystemError,
  setFieldsValidationError,
  setPageErrorMsg,
  setInlineMsg,
  setApiError
) => {
  if (error && isGenericError({ error })) {
    setSystemError(true)

    const reportingData = {
      isError: true,
      genericError: true
    }
    PageviewTealiumEvent(PAGE_NAMES.VERIFY_BILL_DAHSBOARD, reportingData)
  } else if (error) {
    const {
      fieldErrorData: {
        CTA,
        isReplaceContent,
        displayMessage,
        inlineMessage,
        pattern,
        showCount
      },
      isRecoverable,
      hasSystemError
    } = getErrorData({
      error,
      // : sessionStorage.errorcode ? errorMock : error,
      pageName: 'addEditErrors'
    })
    let { message } = getErrorData({
      error,
      // : sessionStorage.errorcode ? errorMock : error,
      pageName: 'addEditErrors'
    })

    if (message !== '') {
      let { billerName } = errorContentCache() || {}
      let getlastComma

      if (billerName.length > 1) {
        if (displayMessage) {
          message = message.replace(message, displayMessage)
        }
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < billerName.length; i++) {
          if (i === billerName.length - 1) {
            billerName[i] = ` and ${billerName[i]}`
          }
        }
        billerName = showCount ? billerName.length : billerName
      }
      let replaceContent = getReplaceContent(message, billerName, pattern)
      if (replaceContent && billerName?.length > 1) {
        getlastComma = replaceContent?.lastIndexOf(',')
        replaceContent =
          replaceContent?.slice(0, getlastComma) +
          replaceContent?.slice(getlastComma + 1)
      }
      setPageErrorMsg(isReplaceContent ? replaceContent : message)
      const reportingData = {
        isError: true,
        genericError: false
        // error
      }
      PageviewTealiumEvent(PAGE_NAMES.VERIFY_BILL_DAHSBOARD, reportingData)
      setFieldsValidationError(true)
      if (hasSystemError) {
        systemErrorCache({
          errorMsg: isReplaceContent ? replaceContent : message,
          CTA,
          hasSystemError,
          isRecoverable,
          billerName
        })
        setSystemError(true)
        setPageErrorMsg(message)
      } else if (inlineMessage) {
        setInlineMsg(inlineMessage)
        setApiError(error)
      }
    } else {
      setSystemError(true)
    }
  }
}

export default handleVerifyBillError
